// footer.js

import React from 'react';
import './footer.css';
import "../../common/css/layout.css";

const Footer = () => {
  return (
      <>
      <div className="component-no-border component-in-row-1">
        <div className="hr_line"></div>
      </div>
      <footer className="footer">
      <div className="footer-item">
        <a href="https://twitter.com/protagonistxyz" target="_blank" rel="noopener noreferrer">
          <i className="fa-brands fa-twitter fa-2xl"></i>
        </a>
      </div>
      <div className="footer-item">
        <a href="https://www.linkedin.com/company/protagonist-co/" target="_blank" rel="noopener noreferrer">
          <i className="fa-brands fa-linkedin fa-2xl"></i>
        </a>
      </div>
      <div className="footer-item">
        <a href="https://www.instagram.com/protagonistxyz/" target="_blank" rel="noopener noreferrer">
          <i className="fa-brands fa-instagram fa-2xl"></i>
        </a>
      </div>
    </footer>
    </>
  );
};

export default Footer;
